import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import config from "../config";
import PageBanner from "./banner";
import WorkerLogoutButton from "./WorkerLogoutButton";

/* =====================
   ICONS
===================== */

const blackIcon = new L.Icon({
  iconUrl:
    "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-black.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41]
});

/* =====================
   COMPONENT
===================== */

const ActivatedPatientMap = () => {
  const workerID = localStorage.getItem("workerID");
  const token = localStorage.getItem("token");

  const [patients, setPatients] = useState([]);
  const [error, setError] = useState(null);

  const fetchActivatedPatients = useCallback(() => {
    if (!workerID || !token) return;

    axios
      .get(`${config.API_BASE_URL}/worker/activated-patients`, {
        params: { workerID },
        headers: { Authorization: `Bearer ${token}` }
      })
      .then((res) => {
        setPatients(res.data.patients || []);
        setError(null);
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          setError("Session expired. Please log in again.");
        } else {
          setError("Failed to load map data.");
        }
      });
  }, [workerID, token]);

  useEffect(() => {
    fetchActivatedPatients();
    const interval = setInterval(fetchActivatedPatients, 15000);
    return () => clearInterval(interval);
  }, [fetchActivatedPatients]);

  return (
    <>
      <PageBanner
        title="Activated Users Map"
        subtitle=""
        rightContent={<WorkerLogoutButton />}
      />

      <div style={layout}>
        <MapContainer
          center={[20, 0]}
          zoom={2}
          minZoom={2}
          style={{ height: "100vh", width: "100%" }}
        >
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

          {/* ACTIVATED PATIENTS */}
          {patients.map((p) =>
            p.latitude && p.longitude ? (
              <Marker
                key={p.patientID}
                position={[p.latitude, p.longitude]}
                icon={blackIcon}
              >
                <Popup maxWidth={300}>
                  <strong>
                    {p.firstName} {p.lastName}
                  </strong>
                  <hr />

                  <p><b>Gender:</b> {p.gender === "M" ? "Male" : "Female"}</p>
                  <p><b>Language:</b> {p.spokenLanguage}</p>
                  <p><b>Location:</b> {p.city}, {p.country}</p>
                  <p><b>Phone:</b> {p.whatsapp}</p>

                  <a
                    href={`https://wa.me/${p.whatsapp.replace("+", "")}`}
                    target="_blank"
                    rel="noreferrer"
                    style={whatsAppBtn}
                  >
                    Contact on WhatsApp
                  </a>
                </Popup>
              </Marker>
            ) : null
          )}
        </MapContainer>
      </div>
    </>
  );
};

export default ActivatedPatientMap;

/* =====================
   STYLES (Copied Structure)
===================== */

const layout = {
  display: "flex",
  height: "100vh"
};

const whatsAppBtn = {
  display: "block",
  marginTop: "10px",
  padding: "8px",
  background: "#25D366",
  color: "#fff",
  textAlign: "center",
  textDecoration: "none",
  borderRadius: "4px"
};
